export const categorizationNumber = (number) => {
   let defaultValue
   if (number !== undefined && number !== null) {  
      return defaultValue =  Number(number).toLocaleString('ru-RU');
    } else {
      return defaultValue = 0;  
    }
}